<template>
  <div>
    <CRow>
      <CCol>
        <CCard>
          <CCardBody>
            <CForm>
              <CTabs>
                <CTab>
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Dados de Cadastro
                  </template>
                  <br />
                  <CAlert
                    color="danger"
                    id="aviso"
                    name="aviso"
                    :show.sync="validacoes.aviso"
                    closeButton
                    >{{ validacoes.msg }}</CAlert
                  >
                  <CAlert
                    color="success"
                    id="sucesso"
                    name="sucesso"
                    :show.sync="validacoes.sucesso"
                    closeButton
                    >{{ validacoes.msg }}</CAlert
                  >
                  <CInput
                    v-model="profissional.name"
                    prepend="Nome"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-badge" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="profissional.cpf"
                    v-mask="maskCpf"
                    @change="validarCpf"
                    prepend="CPF"
                    autocomplete="cpf"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-bank" />
                    </template>
                  </CInput>
                  <CInput
                    type="number"
                    v-model="profissional.rg"
                    invalid-feedback="* Campo obrigatório"
                    prepend="RG"
                  >
                    <template #append-content>
                      <CIcon name="cil-user" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="profissional.crp"
                    v-mask="maskCrp"
                    prepend="CRP"
                    autocomplete="crp"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-at" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="profissional.address"
                    prepend="ENDEREÇO"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-phone" />
                    </template>
                  </CInput>

                  <CInput
                    v-model="profissional.occupation"
                    prepend="OCUPAÇÃO"
                    autocomplete="Ocupação"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>

                  <CInput
                    type="email"
                    required
                    v-model="profissional.email"
                    prepend="EMAIL"
                    autocomplete="Email"
                    invalid-feedback="* Campo obrigatorio"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <!-- <CSelect
                    :value.sync="profissional.sala"
                    :options="salas"
                    v-model="profissional.sala"
                    prepend="SALA"
                    autocomplete="Email"
                    invalid-feedback="* Campo obrigatorio"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect> -->
                  <CInput
                    v-model="profissional.city"
                    prepend="CIDADE"
                    autocomplete="Cidade"
                    invalid-feedback="* Campo obrigatorio"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="profissional.phone"
                    v-mask="maskTel"
                    prepend="TELEFONE"
                    autocomplete="Telefone"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>

                  <CInput
                    v-model="profissional.username"
                    prepend="Usuario"
                    autocomplete="Telefone"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>

                  <CInput
                    v-model="profissional.senha"
                    prepend="SENHA"
                    type="password"
                    invalid-feedback="* Campo obrigatório"
                    @input="validarSenha"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <p class="red" v-for="(item,index) of erros" :key="index">{{ item }}</p>
                  
                  <CButton color="success" @click="editarProfissional()"
                    >Atualizar</CButton
                  >
                  <CButton
                    style="margin-left: 10px"
                    color="info"
                    @click="voltar()"
                    >Voltar</CButton
                  >
                </CTab>
                <CTab :disabled="templateConvenio">
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Valores-PPR
                  </template>
                  <br />
                  <div class="row">
                    <div class="col-4" v-for="item of convenio" :key="item.id">
                      <CInput
                        required
                        :prepend="item.label"
                        v-model="item.percentage"
                        type="text"
                        invalid-feedback="* Campo obrigatório"
                        v-mask="item.mask"
                        :placeholder="placeHolder"
                        pattern="\d+(.\d{2})?"
                        @input="changeValue($event, item.id)"
                        @focus="inputFocus($event, item.id)"
                        @blur="inputBlur()"
                      >
                      </CInput>
                    </div>
                  </div>
                  <CButton color="success" @click="atualizarConvenio()"
                    >Atualizar</CButton
                  >
                  <CButton
                    style="margin-left: 10px"
                    color="info"
                    @click="voltar()"
                    >Voltar</CButton
                  >
                </CTab>
                <CTab>
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Sala
                  </template>
                  <CRow style="display: flex; margin-top: 2rem;">
                    <CCol
                      col="4"
                      v-for="(itemArray, index) of diasDaSemana"
                      :key="index"
                    >
                      <CCard>
                        <CCardHeader>
                          <div id="flex">
                            <h4>{{ itemArray.dia }}</h4>
                            <CAlert

                              :color="itemArray.corAlert"
                              v-show="itemArray.showAlert"
                              >{{ itemArray.message }}</CAlert
                            >
                          </div>
                        </CCardHeader>
                        <CCardBody>
                          <div
                            v-for="(item, index) of itemArray.dados"
                            :key="index"
                          >
                            <CButtonClose @click="retirarHorario(itemArray.dia,item.id)"/>
                            <CSelect
                              :options="salas"
                              :value.sync="item.sala"
                              v-model="item.sala"
                              @change="item.turno = null"
                            ></CSelect>
                            <CSelect
                              :options="turnos"
                              :value.sync="item.turno"
                              v-model="item.turno"
                              @change="changeTurno(item, itemArray.value)"
                            ></CSelect>
                            <hr v-if="itemArray.dados.length > 1" />
                          </div>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                </CTab>
              </CTabs>
            </CForm>
          </CCardBody>
          <CCardBody>
            <CAlert
              color="danger"
              id="aviso"
              name="aviso"
              :show.sync="validacoes.aviso"
              closeButton
              >{{ validacoes.msg }}</CAlert
            >
            <CAlert
              color="success"
              id="sucesso"
              name="sucesso"
              :show.sync="validacoes.sucesso"
              closeButton
              >{{ validacoes.msg }}</CAlert
            >
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
export default {
  name: "CadastrarProfissional",
  data() {
    return {
      erros: [],
      isActive: true,
      maskCrp: "##/#####",
      maskCpf: "###.###.###-##",
      maskTel: "(##) #####.####",
      placeHolder: "",
      templateConvenio: true,
      validacoes: {
        sucesso: false,
        aviso: false,
        msg: "",
        statusDados: false,
        ifs: false,
      },

      convenio: [],

      profissional: {
        id: "",
        name: "",
        cpf: "",
        rg: "",
        crp: "",
        address: "",
        occupation: "",
        email: "",
        city: "",
        phone: "",
        sala: "",
        senha:""
      },
      items: [],
      oldValuePercentage: "",
      idValuePercentage: "",
      salas: [],
      diasDaSemana: [
        {
          id:'',
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Segunda-feira",
          value: "segunda_feira",
          dados: [],
        },
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Terça-feira",
          value: "terca_feira",
          dados: [],
        },
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Quarta-feira",
          value: "quarta_feira",
          dados: [],
        },
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Quinta-feira",
          value: "quinta_feira",
          dados: [],
        },
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Sexta-feira",
          value: "sexta_feira",
          dados: [],
        },
        
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Sábado",
          value: "sabado",
          dados: [],
        },
      ],
      turnos: [
        { label: "", value: null },
        { label: "Manha", value: "manha" },
        { label: "Tarde", value: "tarde" },
        { label: "Manha e Tarde", value: "manha_tarde" },
      ],
    };
  },
  methods: {
    changeValue(item, id) {
      this.convenio.forEach((conv) => {
        if (conv.id == id) {
          if (
            conv.percentage.length > 2 &&
            conv.label != "Particular" &&
            conv.label != "Particular 805" &&
            conv.label != "Proap"
          ) {
            conv.mask = "R$ ##,##";
          } else {
            conv.mask = "% ##,00";
          }
        }
      });
    },
    inputFocus(item, id) {
      this.convenio.forEach((item) => {
        if (item.id == id) {
          this.oldValuePercentage = item.percentage;
          this.idValuePercentage = item.id;
          this.placeHolder = `${item.percentage}`;
          item.percentage = "";
        }
      });
    },
    inputBlur() {
      this.convenio.forEach((item) => {
        if (item.id == this.idValuePercentage) {
          if (item.percentage === "") {
            item.percentage = this.oldValuePercentage;
          }
        }
      });
    },
    voltar() {
      this.$router.push("/profissionais");
    },
    popularDados(id) {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissionais/editar/${id}`)
        .then((res) => res.json())
        .then((res) => {
          this.profissional = res[0];
        })
        .then((res) => {
          this.$http
            .get(
              `${process.env.VUE_APP_API_BASE_URL}profissionais/convenio/${id}`
            )
            .then((res) => res.json())
            .then((res) => {
              res.forEach((item) => {
                if (
                  item.name == "Particular" ||
                  item.name == "Particular 805" ||
                  item.name == "Proap"
                ) {
                  item.percentage = "% " + item.percentage.toFixed(2);
                } else {
                  item.percentage = item.percentage.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  });
                }
              });

              for (let i = 0; i < this.convenio.length; i++) {
                for (let j = 0; j < res.length; j++) {
                  if (this.convenio[i].id == res[j].id_insurance) {
                    this.convenio[i].percentage = res[j].percentage;
                  }
                }
              }
            });
        });
    },
    validarCpf() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissionais`)
        .then((res) => {
          this.items = res.data;
          this.items.forEach((item) => {
            if (this.profissional.cpf === item.cpf) {
              this.validacoes.msg =
                "CPF inválido, já existe um cadastro com este cpf";
              this.validacoes.aviso = true;
              setTimeout(() => {
                this.validacoes.aviso = false;
              }, 3000);
              this.profissional.cpf = "";
            }
          });
        });
    },
    iniciarDiasSemana(){
      this.diasDaSemana = [
        {
          id:'',
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Segunda-feira",
          value: "segunda_feira",
          dados: [],
        },
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Terça-feira",
          value: "terca_feira",
          dados: [],
        },
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Quarta-feira",
          value: "quarta_feira",
          dados: [],
        },
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Quinta-feira",
          value: "quinta_feira",
          dados: [],
        },
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Sexta-feira",
          value: "sexta_feira",
          dados: [],
        },
        
        {
          corAlert:'',
          showAlert: false,
          message: "",
          dia: "Sábado",
          value: "sabado",
          dados: [],
        },
      
      ]
    },
    retirarHorario(diaP,id){
      this.$http.delete(`${process.env.VUE_APP_API_BASE_URL}profissionais/sala/${id}`)
        .then((res)=>{
          this.iniciarDiasSemana()
          this.listarSalasPorTurno()
        })
    },
    converterMaiuscula(string) {
      const substring = string
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, function(p) {
          return p.toUpperCase();
        });
      return substring;
    },

    editar() {
      let valoresConvertidos = {
        name: this.converterMaiuscula(this.profissional.name),
        address: this.converterMaiuscula(this.profissional.address),
        occupation: this.converterMaiuscula(this.profissional.occupation),
        city: this.converterMaiuscula(this.profissional.city),
      };
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}profissionais/atualizar`, {
          valoresConvertidos,
          profissional: this.profissional,
        })
        .then((res) => {
          this.validacoes.sucesso = true;
          this.validacoes.msg = "Cadastro atualizado com sucesso";
          setTimeout((res) => {
            this.$router.push("/profissionais");
          }, 500);
        });
    },
    // validar campos msg's por input
    validarCampos() {
      if (!this.profissional.name) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Nome do profissional precisa ser preenchido";
      } else if (!this.profissional.cpf) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "CPF do profissional precisa ser preenchido";
      } else if (!this.profissional.rg) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "RG do profissional precisa ser preenchido";
      } else if (!this.profissional.crp) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "CRP do profissional precisa ser preenchido";
      } else if (!this.profissional.address) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Endereço do profissional precisa ser preenchido";
      } else if (!this.profissional.occupation) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Ocupação do profissional precisa ser preenchido";
      } else if (!this.profissional.email) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Email do profissional precisa ser preenchido";
      } else if (!this.profissional.city) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Cidade do profissional precisa ser preenchido";
      } else if (!this.profissional.phone) {
        this.validacoes.aviso = true;
        this.validacoes.msg = "Telefone do profissional precisa ser preenchido";
      } else {
        this.validacoes.ifs = true;
      }
    },
    editarProfissional() {
      this.validarCampos();
      if(this.erros.length > 0 && this.profissional.senha.length != 0){
        this.validacoes.aviso = true;
        this.validacoes.msg =
              "Senha invalida";
        return
      }
      const expEmail = /[^\n]+@\S+\.\S+/;

      if (this.validacoes.ifs) {
        if (expEmail.test(this.profissional.email)) {
          if (this.profissional.cpf.length == 14) {
            this.validacoes.statusDados = false;
            this.editar();
          } else {
            this.profissional.cpf = "";
            this.validacoes.aviso = true;
            this.validacoes.msg =
              "CPF Inválido, caracteres inseridos não podem ser inferior a 11 digitos";
            setTimeout(() => {
              this.validacoes.aviso = false;
            }, 3000);
          }
        } else {
          this.validacoes.aviso = true;
          this.validacoes.msg = "Endereço de email inválido";
          setTimeout(() => {
            this.validacoes.aviso = false;
          }, 3000);
        }
      }
    },
    atualizarConvenio() {
      let id = this.profissional.id;
      let array = this.convenio.map((item) => {
        return {
          ...item,
          percentage: Number(
            item.percentage.replace(/[%R$]/g, "").replace(",", ".")
          ),
          profissional: id,
        };
      });

      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}convenios/cadastro`, {
          convenio: array,
        })
        .then((res) => res.json())
        .then((res) => {
          this.validacoes.msg = "Convênio cadastrado com sucesso";
          this.validacoes.sucesso = true;
          setTimeout(() => {
            this.validacoes.sucesso = false;
          }, 3000);
        });
    },
    convenios() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}convenios`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            if (item.name == "Coparticipação Saúde Pas") {
              item.name = "Copart. Saúde Pas";
            }
            this.convenio.push({
              label: item.name,
              id: item.id,
              percentage: "",
              placeHolder: this.placeHolder,
              profissional: this.$route.params.id,
            });
          });
        });
    },
    verifiUserTemplateConvenio() {
      if (localStorage.getItem("type") == 1) {
        this.templateConvenio = false;
      } else {
        this.templateConvenio = true;
      }
    },
    ListarSalas() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}salas`)
        .then((res) => res.json())
        .then((res) => {
          this.salas = res.map((x) => {
            return {
              label: `Sala ${x.sala} - ${x.andar}° Andar `,
              value: x.sala,
            };
          });
          this.salas.unshift({
            label: "",
            value: null,
          });
        });
    },
    changeTurno(item, dia) {
      if(!item.turno){
        return
      }
      item.value = dia;
      let urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get("id");
      item.user = id;
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}profissional/sala`, item)
        .then((res) => res.json())
        .then((res)=>{
          this.diasDaSemana.forEach((item) => {
            if (item.value == dia) {
              item.corAlert = 'success'
              item.showAlert = true;
              item.message = "Feito !";
              setTimeout(() => {
                item.showAlert = false;
              }, 5000);
            }
          });
        })
        .catch((err) => {
          this.diasDaSemana.forEach((item) => {
            if (item.value == dia) {
              item.corAlert = 'warning'
              item.showAlert = true;
              item.message = err.body.message;
              setTimeout(() => {
                item.showAlert = false;
              }, 5000);
            }
          });
          return;
        });
      this.diasDaSemana.forEach((x) => {
        x.dados = [];
      });
      setTimeout(() => {
        this.listarSalasPorTurno();
      }, 1000);
    },
    listarSalasPorTurno() {
      let urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get("id");

      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissional/sala/${id}`)
        .then((res) => res.json())

        .then((res) => {
          
          res.forEach((item) => {
            this.diasDaSemana.forEach((data) => {
      
              if (item.day == data.value) {
                data.dados.push({
                  id: item.id,
                  trabalha: false,
                  sala: item.room.toString(),
                  turno: item.shift,
                });
              }
            });
          });

          this.diasDaSemana.forEach((item) => {
            if (item.dados.length == 0) {
              item.dados.push({
                sala: "",
                trabalha: false,
                turno: "",
              });
            }
            if (
              item.dados.length == 1 &&
              (item.dados[0].turno == "manha" || item.dados[0].turno == "tarde")
            ) {
              item.dados.push({
                sala: "",
                trabalha: false,
                turno: "",
              });
            }
          });
        });
    },
    validarSenha() {
      this.erros = []
      const senha = this.profissional.senha;
      const hasUppercase = /[A-Z]/.test(senha);
      const hasSpecialChar = /[^a-zA-Z0-9]/.test(senha);
      const hasLettersAndNumbers =
        /[a-zA-Z]/.test(senha) && /[0-9]/.test(senha);

      if(senha.length < 6){
        this.erros.push("A senha deve ter 6 ou mais caracteres.");
      }
      if (!hasUppercase) {
        this.erros.push("A senha deve conter pelo menos uma letra maiúscula.");
      }

      if (!hasSpecialChar) {
        this.erros.push("A senha deve conter pelo menos um caractere especial.");
      }

      if (!hasLettersAndNumbers) {
        this.erros.push("A senha deve conter letras e números.");
      }

      if (this.erros.length > 0) {
        // Exibir alertas de erro
        for (let erro of this.erros) {
          console.log(erro);
        }
      } else {
        // A senha atende aos critérios de validação
        console.log("A senha é válida");
      }
    },
  },

  mounted() {
    this.verifiUserTemplateConvenio();
    this.ListarSalas();
    let id = this.$route.query.id;
    this.popularDados(id);
    this.convenios();
    this.listarSalasPorTurno();
  },
};
</script>
<style scoped>
.active .input-group-prepend {
  color: red;
}
#d-flex {
  display: flex !important;
  flex-direction: row;
}
#flex {
  display: flex;
  justify-content: space-between;
}
h4 {
  margin: 0px;
}
.red{
  color: red;
  margin-bottom: 0px;
}
</style>
